import { Injectable, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ICardAction } from "@tylertech/tyler-api-types";
import { PacketDetailDialogComponent, PacketDetailDialogData } from "../components/packetDetail/packetDetailDialog.component";

@Injectable({ providedIn: "root" })
export class PacketDialogsService
{
    private readonly matDialog = inject(MatDialog);


    show(
        packetId: string,
        aggregateId: string,
        packetType: string,
        packetNumber: string,
        cardActions: ICardAction[],
        alternateType?: string
    ): Promise<ICardAction>
    {
        const config: MatDialogConfig<PacketDetailDialogData> = {
            data: {
                packetId,
                aggregateId,
                packetType,
                packetNumber,
                cardActions,
                alternateType
            }
        };
        const dialogRef = this.matDialog.open(PacketDetailDialogComponent, config);
        return dialogRef.afterClosed().toPromise();
    }
}
